import { InjectableService } from "@/shared/services/InjectableService";
import { WizardModel } from "../models/WizardModel";
import { WizardStep } from "../models/WizardStep";


export abstract class WizardFactory<TSharedModel,
    TStep extends WizardStep<TSharedModel>,
    TModel extends WizardModel<TStep, TSharedModel>> extends InjectableService {

    public abstract createWizardModel(): TModel;

}